import axios from "axios";
import { APIS } from "../../../../utils/api-factory";
import { GET_HEADER, POST_HEADER, MULTIPART_POST_HEADER } from "../../../../utils/apiHeaders";

export const saveDoctorProducts = (data, callBack, error) => {
    axios.post(APIS.SAVE_DOC_PRODUCTS, data, { headers: POST_HEADER })
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            console.log(e)
            error(e.response?.data || e)
        })
}
export const getDoctorProducts = (pageNo, noOfEntry, nbfcId, callBack, error) => {
    axios.get(APIS.GET_DOC_PRODUCTS + pageNo + '&noOfEntry=' + noOfEntry + '&nbfcId=' + nbfcId, GET_HEADER)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            console.log(e)
            error(e.response?.data || e)
        })
}
export const getDoctorProductsCount = (nbfcId, callBack, error) => {
    axios.get(APIS.GET_PRODUCTS_COUNT + '?nbfcId=' + nbfcId, GET_HEADER)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            console.log(e)
            error(e.response?.data || e)
        })
}
export const deleteDoctorProduct = (id, callBack, error) => {
    axios.delete(APIS.DELETE_PRODUCTS + id, GET_HEADER)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            console.log(e)
            error(e.response?.data || e)
        })
}
export const getProductFromNbfcId = (nbfcId, callBack, error) => {
    axios.get(APIS.GET_PRODUCT_BY_NBFC_ID_NEW + nbfcId, GET_HEADER)
        .then(res => {
            console.log(res)
            callBack(res.data.data)
        })
        .catch(e => {
            console.log(e)
        })
}
export const getCalculationDoctor = (productId, loanAmount, callBack, error) => {
    axios.get(APIS.GET_CALCULATION + productId + '&loanAmount=' + loanAmount, GET_HEADER)
        .then(res => {
            console.log(res)
            callBack(res.data)
        })
        .catch(e => {
            console.log(e)
        })
}
export const editCalculationApi = (data, callBack, error) => {
    axios.post(APIS.EDIT_CALCULATION, data, { headers: POST_HEADER })
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            console.log(e)
            error(e.response?.data || e)
        })
}
export const getDoctorProductsNew = (doctorId, assign, callBack, error) => {
    axios.get(APIS.GET_PRODUCT_BY_DOCTORID + doctorId + '&assign=' + assign, GET_HEADER)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            console.log(e)
            error(e.response?.data || e)
        })
}

export const assignProductToDoctor = (doctorId, productId, callBack, error) => {
    axios.get(APIS.ASSIGN_PRODUCT_TO_DOCTOR + doctorId + '&productId=' + productId, GET_HEADER)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            console.log(e)
            error(e.response?.data || e)
        })
}
export const activeInactiveProductApi = (status, productId, callBack, error) => {
    axios.get(APIS.CHANGE_PRODUCT_STATUS + status + '&productId=' + productId, GET_HEADER)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            console.log(e)
            error(e.response?.data || e)
        })
}
export const unassignProductToDoctor = (doctorId, productId, callBack, error) => {
    axios.delete(APIS.UN_ASSIGN_PRODUCT_TO_DOCTOR + doctorId + '&productId=' + productId, GET_HEADER)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            console.log(e)
            error(e.response?.data || e)
        })
}
export const uploadDoctorFile = (file, callBack, error) => {
    let multipartFormData = new FormData()
    multipartFormData.append('file', file)

    axios.post(APIS.UPLOAD_DOCTOR_RATING_FILE, multipartFormData, { headers: MULTIPART_POST_HEADER })
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e.response?.data || e)
        })
}
export const saveProocessingFeeTypeApi = (productId, processigFeeType , callBack, error) => {
    axios.get(APIS.SAVE_PROCESSING_FEE_TYPE + productId + '&type=' + processigFeeType, GET_HEADER)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            console.log(e)
            error(e.response?.data || e)
        })
}
export const getAllOrganisation = (callBack, error) => {
    axios.get(APIS.GET_ALL_ORGANISATION, GET_HEADER)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            console.log(e)
            error(e.response?.data || e)
        })
}
